import { TextField } from '@shared/ui/kit';
import { Tiptap } from '@shared/ui/tiptap';
import { StylesText } from '@entities/leadCollector';
import { InfoFilledIcon } from '@shared/assets/icons';
import clsx from 'clsx';
import styles from './ticket-text-field.module.scss';

interface TicketTextFieldProps {
  isSmsTicketMode: boolean;
  isBothTicketMode: boolean;
  isLocked: boolean;
  showSmsCounter?: boolean;
  ticketSmsText: string;
  ticketText: string;
  ticketTextParts: number;
  ticketTextError?: string | null;
  onTicketTextChange: (value: string) => void;
}

export const TicketTextField = ({
  isSmsTicketMode,
  isBothTicketMode,
  isLocked,
  showSmsCounter = true,
  ticketSmsText,
  ticketText,
  ticketTextParts,
  ticketTextError,
  onTicketTextChange,
}: TicketTextFieldProps) => {
  if (isSmsTicketMode) {
    return (
      <div className={styles.textFieldWrapper}>
        <div className={styles.textFieldHeader}>
          <div className={styles.lockedTextLabelWrap}>
            <p className={styles.textFieldLabel}>Текст билета</p>
          </div>
          {!isLocked && showSmsCounter && (
            <p className={styles.textCounter}>
              {ticketSmsText.length} ({ticketTextParts} смс)
            </p>
          )}
        </div>
        <TextField
          labelMsg=""
          changeFunction={(event) => onTicketTextChange(event.target.value)}
          placeholder="Введите текст"
          value={ticketText}
          status={ticketTextError ? 'error' : 'default'}
          textareaMessage={ticketTextError ?? undefined}
          isDisabled={isLocked}
          settings={{
            width: '100%',
            cursor: 'text',
            resize: 'vertical',
            height: 'auto',
            minHeight: '102px',
            maxHeight: '228px',
            overflow: 'auto',
          }}
        />
      </div>
    );
  }

  return (
    <div className={styles.textFieldWrapper}>
      <div className={styles.textFieldHeader}>
        <div className={styles.lockedTextLabelWrap}>
          <p className={styles.textFieldLabel}>Текст билета</p>
        </div>
      </div>
      <div className={clsx(styles.formattedTextEditor, isLocked && styles.formattedTextEditorDisabled)}>
        <Tiptap
          className={clsx(styles.formattedTextEditorContent, isLocked && styles.formattedTextEditorContentReadOnly)}
          placeholder="Введите текст"
          onChange={onTicketTextChange}
          properties={{ link: true, styles: [StylesText.BOLD, StylesText.ITALIC, StylesText.UNDERLINE] }}
          withToolbar
          editable={!isLocked}
          hiddenStyles={[StylesText.LEFT, StylesText.CENTER, StylesText.RIGHT, StylesText.JUSTIFY]}
          content={ticketText}
        />
      </div>
      {ticketTextError && <p className={styles.ticketTextValidationFloating}>{ticketTextError}</p>}
      {isBothTicketMode && (
        <div className={styles.formattingInfoAlert}>
          <span className={styles.formattingInfoAlertIcon}>
            <InfoFilledIcon size="16" />
          </span>
          <span>Форматирование будет применено только к email</span>
        </div>
      )}
    </div>
  );
};
